export const HEADING = "Change hotel reservation";
export const SUBHEADING_AGENT =
  "To change this hotel booking, please contact our customer support team and someone will assist you";
export const SUBHEADING =
  "This booking is managed by the hotel. To change this reservation, please contact the hotel directly.";
export const CONTACT_SUPPORT = "Contact support";
export const CANCEL = "Cancel";
export const DONE = "Done";
